import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Paper,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { motion } from "framer-motion";
import axios from "axios";
import Layout from "../components/layout/GSTlayout";
import configuration from "../config.js";

const EwayBillForm = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      supplierGSTIN: "",
      receiverGSTIN: "",
      documentType: "",
      documentNumber: "",
      documentDate: "",
      valueOfGoods: "",
      transporterName: "",
      transporterGSTIN: "",
      vehicleNumber: "",
    },
  });
  const { API_BASE_URL } = configuration;

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/generate-ewb`,
        data
      );
     

      alert("E-way Bill Generated Successfully!");

      reset();
    } catch (error) {
      console.error("Error generating E-way Bill:", error);
      alert("Error generating E-way Bill");
    }
  };

  return (
    <Layout>
      <Container component="main" maxWidth="md">
        <Paper
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          elevation={3}
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 4,
          }}
        >
          <Typography component="h1" variant="h5">
            E-way Bill Generation
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            sx={{ mt: 3, width: "100%" }}
          >
            <Grid container spacing={2}>
              {[
                {
                  name: "supplierGSTIN",
                  label: "Supplier GSTIN",
                  rules: {
                    required: "Supplier GSTIN is required",
                    pattern: {
                      value:
                        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                      message: "Invalid GSTIN format",
                    },
                  },
                },
                {
                  name: "receiverGSTIN",
                  label: "Receiver GSTIN",
                  rules: {
                    required: "Receiver GSTIN is required",
                    pattern: {
                      value:
                        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                      message: "Invalid GSTIN format",
                    },
                  },
                },
                {
                  name: "documentType",
                  label: "Document Type",
                  rules: { required: "Document Type is required" },
                },
                {
                  name: "documentNumber",
                  label: "Document Number",
                  rules: { required: "Document Number is required" },
                },
                {
                  name: "transporterName",
                  label: "Transporter Name",
                  rules: { required: "Transporter Name is required" },
                },
                {
                  name: "transporterGSTIN",
                  label: "Transporter GSTIN",
                  rules: {
                    required: "Transporter GSTIN is required",
                    pattern: {
                      value:
                        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                      message: "Invalid GSTIN format",
                    },
                  },
                },
                {
                  name: "vehicleNumber",
                  label: "Vehicle Number",
                  rules: { required: "Vehicle Number is required" },
                },
              ].map((field) => (
                <Grid item xs={12} sm={6} key={field.name}>
                  <Controller
                    name={field.name}
                    control={control}
                    rules={field.rules}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        fullWidth
                        variant="outlined"
                        label={field.label}
                        onChange={onChange}
                        value={value}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    )}
                  />
                </Grid>
              ))}

              <Grid item xs={12} sm={6}>
                <Controller
                  name="documentDate"
                  control={control}
                  rules={{ required: "Document Date is required" }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      fullWidth
                      type="date"
                      variant="outlined"
                      label="Document Date"
                      InputLabelProps={{ shrink: true }}
                      onChange={onChange}
                      value={value}
                      error={!!errors.documentDate}
                      helperText={errors.documentDate?.message}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Controller
                  name="valueOfGoods"
                  control={control}
                  rules={{
                    required: "Value of Goods is required",
                    validate: (value) => value > 0 || "Value must be positive",
                  }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      fullWidth
                      type="number"
                      variant="outlined"
                      label="Value of Goods"
                      onChange={onChange}
                      value={value}
                      error={!!errors.valueOfGoods}
                      helperText={errors.valueOfGoods?.message}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  component={motion.button}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  sx={{ mt: 3, mb: 2 }}
                >
                  Generate E-way Bill
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </Layout>
  );
};

export default EwayBillForm;
